import ListView from "../../component/ListView";
import {Column} from "primereact/column";
import * as React from "react";
import rest from "../../utils/EnvConfig";
import Restaurante from "../../model/Restaurante";
import styles from "./Restaurante.module.css";
import {Button} from "primereact/button";
import {PrimeIcons} from "primereact/api";
import {useNavigate} from "react-router-dom";
import {useKeycloak} from "../../keycloak/useKeycloak";
import {TipoUsuarioKeycloak} from "../../keycloak/TipoUsuarioKeycloak";
import {RoleBasedAccess} from "../../keycloak/RoleBasedAccess";
import {UsuarioKeycloak} from "../../model/UsuarioKeycloak";
import RestauranteCardapioComida from "../../model/RestauranteCardapioComida";

function RestauranteCardapioComidaList() {
    const {hasRole, user} = useKeycloak();
    const navigate = useNavigate();

    const obterRecursoCorreto = (): string | undefined => {
        if (hasRole(TipoUsuarioKeycloak.ADMIN)) {
            return `${rest.restauranteCardapioComida}/${rest.obterTodos}`;
        }

        if (hasRole(TipoUsuarioKeycloak.CLIENTE)) {
            return `${rest.restauranteCardapioComida}/${rest.cardapiosComidaPorUsuario}${user.id}`;
        }

        return "";
    }

    const botoesExtra = (entidade: Restaurante, rowIndex?: number): React.JSX.Element[] => {
        return [
            (
                <>
                    <Button icon={PrimeIcons.CAMERA} className={`${styles.espacamentoBotoes} mr-2`} raised
                        title={"Envio de fotos"} onClick={(event: any) => navigate(`/restaurante/cardapio/comida/imagem/${entidade.uuid}`)}
                        severity="success" />
                </>
            )];
    }

    const restaurantesTemplate = (cardapioComida: RestauranteCardapioComida) => {
        return cardapioComida.restaurantes?.
            map(r => r.nomeEstabelecimento).reduce((v, acc) => v + "," + acc);
    }

    return (
        <>
            <RoleBasedAccess roles={TipoUsuarioKeycloak.ADMIN}>
                <ListView title={"Restaurante - Cardápio de comida"}
                      restCustom={obterRecursoCorreto()}
                      botoesAdicionais={botoesExtra}
                      visibleExcluir={(entidade) => hasRole(TipoUsuarioKeycloak.ADMIN)}
                      id={`${rest.restauranteCardapioComida}`}>
                    <Column field="nomeCardapio" header="Título do cardápio" sortable/>
                    <Column field="restaurantes" header="Restaurantes" body={restaurantesTemplate} sortable/>
                </ListView>
            </RoleBasedAccess>

            <RoleBasedAccess roles={TipoUsuarioKeycloak.CLIENTE}>
                <ListView title={"Restaurante - Cardápio de comida"}
                          restCustom={obterRecursoCorreto()}
                          botoesAdicionais={botoesExtra}
                          visibleExcluir={(entidade) => hasRole(TipoUsuarioKeycloak.ADMIN)}
                          id={`${rest.restauranteCardapioComida}`}>
                    <Column field="nomeCardapio" header="Título do cardápio" sortable/>
                </ListView>
            </RoleBasedAccess>
        </>
    );
}

export default RestauranteCardapioComidaList;